import React from 'react';
import { Clock, IndianRupee, Star, BookOpen, ChevronRight, Check } from 'lucide-react';

export default function ProgramCard({ course, onSelectSyllabus, onApplyClick }) {
  return (
    <div className="glass-card" style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: '#FFFFFF',
      border: '1px solid rgba(226, 232, 240, 0.8)',
      borderRadius: '16px'
    }}>
      {/* Top Banner Image with Gradient Overlay */}
      <div style={{
        position: 'relative',
        height: '180px',
        overflow: 'hidden',
        backgroundColor: '#0F2537'
      }}>
        <img
          src={course.image}
          alt={course.name}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: 0.85,
            transition: 'transform 0.5s ease'
          }}
        />
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(to bottom, rgba(15, 37, 55, 0.2) 0%, rgba(15, 37, 55, 0.85) 100%)'
        }} />

        {/* Badge */}
        <div style={{ position: 'absolute', top: '1rem', left: '1rem' }}>
          <span className="badge-gold">
            {course.badge}
          </span>
        </div>

        {/* Degree Level Badge */}
        <div style={{ position: 'absolute', top: '1rem', right: '1rem' }}>
          <span className="badge-blue" style={{ backgroundColor: 'rgba(15, 37, 55, 0.85)', color: '#FEF08A', border: '1px solid rgba(255, 255, 255, 0.2)' }}>
            {course.type === 'UG' ? 'Undergraduate' : 'Postgraduate'}
          </span>
        </div>

        {/* Rating overlay */}
        <div style={{
          position: 'absolute',
          bottom: '0.85rem',
          left: '1rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.35rem',
          color: '#FEF08A',
          fontSize: '0.85rem',
          fontWeight: 700
        }}>
          <Star size={16} fill="#D4AF37" color="#D4AF37" />
          <span>{course.rating}</span>
          <span style={{ color: '#CBD5E1', fontWeight: 400, fontSize: '0.78rem' }}>({course.reviewsCount} reviews)</span>
        </div>
      </div>

      {/* Card Content Body */}
      <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        <div style={{ fontSize: '0.8rem', color: '#2563EB', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          {course.category}
        </div>

        <h3 style={{ fontSize: '1.25rem', fontWeight: 800, color: '#0F2537', marginTop: '0.25rem', marginBottom: '0.5rem', lineHeight: 1.3 }}>
          {course.name}
        </h3>

        <p style={{ fontSize: '0.88rem', color: '#475569', lineHeight: 1.5, marginBottom: '1.25rem', flexGrow: 1 }}>
          {course.subtitle}
        </p>

        {/* Key Info Bar */}
        <div style={{
          backgroundColor: '#F8FAFC',
          borderRadius: '10px',
          padding: '0.85rem 1rem',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '0.75rem',
          marginBottom: '1.25rem',
          border: '1px solid #E2E8F0'
        }}>
          <div>
            <div style={{ fontSize: '0.75rem', color: '#64748B', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
              <Clock size={13} /> Duration
            </div>
            <div style={{ fontSize: '0.9rem', fontWeight: 700, color: '#0F2537', marginTop: '0.15rem' }}>
              {course.durationYears} Years
            </div>
          </div>

          <div>
            <div style={{ fontSize: '0.75rem', color: '#64748B', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
              <IndianRupee size={13} /> Total Course Fee
            </div>
            <div style={{ fontSize: '0.95rem', fontWeight: 800, color: '#059669', marginTop: '0.15rem' }}>
              ₹{course.totalFee.toLocaleString('en-IN')}
            </div>
          </div>
        </div>

        {/* Key Highlights */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '1.5rem' }}>
          {course.keyHighlights.slice(0, 3).map((item, idx) => (
            <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', fontSize: '0.82rem', color: '#334155' }}>
              <Check size={14} color="#059669" style={{ flexShrink: 0, marginTop: '2px' }} />
              <span>{item}</span>
            </div>
          ))}
        </div>

        {/* EMI Tag */}
        <div style={{
          fontSize: '0.8rem',
          color: '#1D4ED8',
          backgroundColor: '#EFF6FF',
          padding: '0.4rem 0.75rem',
          borderRadius: '6px',
          marginBottom: '1.25rem',
          fontWeight: 600,
          textAlign: 'center'
        }}>
          💳 Easy No-Cost EMI starts @ ₹{course.emiStarts.toLocaleString('en-IN')}/month
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginTop: 'auto' }}>
          <button
            onClick={() => onSelectSyllabus(course)}
            className="btn-outline"
            style={{ padding: '0.65rem', fontSize: '0.82rem', width: '100%' }}
          >
            <BookOpen size={14} /> Syllabus
          </button>
          
          <button
            onClick={() => onApplyClick(course)}
            className="btn-primary"
            style={{ padding: '0.65rem', fontSize: '0.82rem', width: '100%', boxShadow: 'none' }}
          >
            Apply Now <ChevronRight size={14} />
          </button>
        </div>

      </div>
    </div>
  );
}
